export default __webpack_public_path__ + "static/media/DefaultProductImage.4936d356.jpg";